import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AppService } from '../../app.service';
import { SignInEvent, HiddenFooter } from './../../shared/message.event';
@Component({
    selector: 'app-privacy-policy',
    templateUrl: 'privacy-policy.component.html',
    styleUrls: ['privacy-policy.component.css'],
    providers: [SignInEvent, HiddenFooter]
})

export class PrivacyPolicyComponent implements OnInit {
    private _router;
    private _appService;
    private windowHeight = window.innerHeight;
    private topNav = 56;
    private midNav = 45;
    private footer = 35;
    private container = 40;
    private height: any;

    constructor(private router: Router, private appService: AppService, private signInEvent: SignInEvent,
    private hiddenFooter: HiddenFooter) {
        this._router = router;
        this._appService = appService;
        this.height = (this.windowHeight - (this.topNav + this.midNav + this.container + this.footer)) + 'px';
    }

    ngOnInit() {
        this.emitTypeBroadcast();
    }
        emitTypeBroadcast() {
            let isShow = {
             privacypolicy: true,
             support: false,
             footer: 'block'
         };
        this.signInEvent.fire('none');
        this.hiddenFooter.fire(isShow);
    }
}


// WEBPACK FOOTER //
// ./src/app/privacy/privacy-policy/privacy-policy.component.ts